import * as React from 'react'
import styled, { css, keyframes } from '@xstyled/styled-components'
import Microphone from '../../svg/Microphone.svg'
import Ear from '../../svg/Ear.svg'
import Mouth from '../../svg/Mouth.svg'
import RoundBorder from '../../svg/RoundBorder.svg'

const IconMap = {
  microphone: Microphone,
  ear: Ear,
  mouth: Mouth,
}

export interface IconProps {
  spinning?: boolean
  disableHover?: boolean
  withBorder?: boolean
  icon: keyof typeof IconMap
}

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`

const MicrophoneWrapper = styled.div`
  position: absolute;
  top: 0%;
  left: 0%;
  width: 100%;
  height: 100%;
`

const RoundBorderWrapper = styled.div<Omit<IconProps, 'icon'>>`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  animation: ${spin} 6s infinite;
  animation-play-state: paused;
  animation-timing-function: linear;
  animation-play-state: ${({ spinning }) => (spinning ? 'running' : 'paused')};

  ${({ disableHover }) =>
    disableHover
      ? ``
      : css`
          &:hover {
            animation-play-state: running;
          }
        `}
`

export const Icon: React.FC<IconProps> = ({
  spinning,
  disableHover,
  withBorder,
  icon,
}) => {
  const IconSVG = IconMap[icon]
  return (
    <div>
      <div>
        <MicrophoneWrapper>
          <IconSVG />
        </MicrophoneWrapper>
      </div>
      {withBorder ? (
        <RoundBorderWrapper spinning={spinning} disableHover={disableHover}>
          <RoundBorder />
        </RoundBorderWrapper>
      ) : null}
    </div>
  )
}
